import { render, staticRenderFns } from "./AbnormalFeedback.vue?vue&type=template&id=147bea51&scoped=true"
import script from "./AbnormalFeedback.vue?vue&type=script&lang=js"
export * from "./AbnormalFeedback.vue?vue&type=script&lang=js"
import style0 from "./AbnormalFeedback.vue?vue&type=style&index=0&id=147bea51&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bea51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147bea51')) {
      api.createRecord('147bea51', component.options)
    } else {
      api.reload('147bea51', component.options)
    }
    module.hot.accept("./AbnormalFeedback.vue?vue&type=template&id=147bea51&scoped=true", function () {
      api.rerender('147bea51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/NotCollectedBasemap/components/AbnormalFeedback.vue"
export default component.exports